// extracted by mini-css-extract-plugin
export default {"wrap":"NoMatchScreen_wrap__bQhLU","inner-wrap":"NoMatchScreen_inner-wrap__fExN5"};